import { Page } from '../../AdvancedEditor';

export class InvalidTextLanguageError extends Error {
    page: Page;
    constructor(page: Page) {
        super('Invalid text for the selected language');
        this.page = page;
        Object.setPrototypeOf(this, InvalidTextLanguageError.prototype);
    }
}
